export const albanianDivisions = {
    "Berat": ["Berat", "Kuçovë", "Poliçan", "Skrapar", "Ura Vajgurore"],
    "Dibër": ["Bulqizë", "Dibër", "Klos", "Mat"],
    "Durrës": ["Durrës", "Krujë", "Shijak"],
    "Elbasan": ["Belsh", "Cërrik", "Elbasan", "Gramsh", "Librazhd", "Peqin", "Prrenjas"],
    "Fier": ["Divjakë", "Fier", "Lushnjë", "Mallakastër", "Patos", "Roskovec"],
    "Gjirokastër": ["Dropull", "Gjirokastër", "Këlcyrë", "Libohovë", "Memaliaj", "Përmet", "Tepelenë"],
    "Korçë": ["Devoll", "Kolonjë", "Korçë", "Maliq", "Pogradec", "Pustec"],
    "Kukës": ["Has", "Kukës", "Tropojë"],
    "Lezhë": ["Kurbin", "Lezhë", "Mirditë"],
    "Shkodër": ["Fushë-Arrëz", "Malësi e Madhe", "Pukë", "Shkodër", "Vau i Dejës"],
    "Tiranë": ["Kamëz", "Kavajë", "Rrogozhinë", "Tiranë", "Vorë"],
    "Vlorë": ["Delvinë", "Finiq", "Himarë", "Konispol", "Sarandë", "Selenicë", "Vlorë"]
};
